/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why this search is being run — the internal flow that triggered it. Callers declare their own purpose; this endpoint serves all of them and cannot infer it. Distinct from user_environment, which records what client the traveler is using: one search is legitimately requestor "mcp_server" and user_environment "CLAUDE" at the same time. Recorded on flight_search_results so search history can be split by purpose.
 * @export
 */
export const FlightSearchRequestor = {
    McpServer: 'mcp_server',
    GondolaChat: 'gondola_chat',
    UserRequest: 'user_request',
    RateUpdate: 'rate_update'
} as const;
export type FlightSearchRequestor = typeof FlightSearchRequestor[keyof typeof FlightSearchRequestor];


export function instanceOfFlightSearchRequestor(value: any): boolean {
    for (const key in FlightSearchRequestor) {
        if (Object.prototype.hasOwnProperty.call(FlightSearchRequestor, key)) {
            if (FlightSearchRequestor[key as keyof typeof FlightSearchRequestor] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FlightSearchRequestorFromJSON(json: any): FlightSearchRequestor {
    return FlightSearchRequestorFromJSONTyped(json, false);
}

export function FlightSearchRequestorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSearchRequestor {
    return json as FlightSearchRequestor;
}

export function FlightSearchRequestorToJSON(value?: FlightSearchRequestor | null): any {
    return value as any;
}

export function FlightSearchRequestorToJSONTyped(value: any, ignoreDiscriminator: boolean): FlightSearchRequestor {
    return value as FlightSearchRequestor;
}

